<template>
    <div class="about">
        <div class="about_center">
            <bannerCenter
                    :box="box"
            ></bannerCenter>
            <div class="about_thr">
                <div class="about_thr_left">
                    <div :class="item.isShow ? 'pageTopHide':'pageTopShow'" v-for="(item, index) in troList" :key="index" @click="isShow(item,index)">
                        <div class="xian"></div>
                        {{item.text}}
                    </div>
                </div>
                <div class="about_thr_right" v-show="introduce">
                    <div class="about_thr_rightO">公司介绍</div>
                    <div class="about_thr_rightT">COMPANY PROFILE</div>
                    <div class="about_thr_rightF"></div>
                    <div class="about_thr_rightF"></div>
                    <div class="about_thr_rightF">逍遥推手结合与时俱进的商业模式与市场需求的时代改变，打造了聚合支付3.0平台，以创新支付产品、多品牌资源整合的互联网+营销新模式，金融产品服务选代升级为平台业务核心，实现支付行业公平、透明、安全、共赢。</div>
                    <div class="about_thr_rightF">十年行业沉淀，我们已经取得了优秀的市场资源并准备在未来的十年内推动100家战略运营平台，做到平台员工以及合作伙伴人人持股、人人轻产、人人致富。</div>
                </div>
                <div class="about_thr_right height" v-show="progress">
                    <div class="about_thr_rightO">发展历程</div>
                    <div class="about_thr_rightT">COMPANY PROFILE</div>
                    <div class="about_thr_progress"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import bannerCenter from '../../components/bannerCenter'
    export default {
        data(){
            return{
                troList:[
                    {
                        text:'公司介绍',
                        isShow:true,
                    },
                    {
                        text:'发展历程',
                        isShow:false,
                    }
                ],
                introduce:true,
                progress:false,
                box:{
                    boxText:'关于我们',
                    boxTextWe:'关于我们',
                    boxTextEn:'ABOUT US'
                }
            }
        },
        components:{
            bannerCenter
        },
        mounted(){

        },
        methods:{
            isShow(item,index){
                for (let item in this.troList) {
                    this.troList[item].isShow = false
                }
                this.troList[index].isShow = true;
                if (index == 0){
                    this.introduce = true;
                    this.progress = false
                }
                if (index == 1){
                    this.progress = true;
                    this.introduce = false
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    .about{
        width: 100%;
        height: 100%;
        background: #ffffff;
        .about_center{
            width: 100%;
            height: calc(100% - 62px);
            top: 62px;
            z-index: -1;
            .about_thr{
                width: 100%;
                flex: 1;
                background: #ffffff;
                display: flex;
                .about_thr_left{
                    width: 91px;
                    background: #ffffff;
                    font-size: 11px;
                    font-family: "Microsoft YaHei UI";
                    font-weight: 400;
                    color: #1E1E1E;
                    padding: 29px 0 0 202px;
                    div:nth-child(1){
                        margin-bottom: 5px;
                        border-bottom: 0.5px solid #EDEDED;
                    }
                    .pageTopHide{
                        display: flex;
                        .xian{
                            width: 2px;
                            height: 15px;
                            background: #3E83FE;
                            margin-right: 9px;
                            border-radius: 2px;
                        }
                    }
                    .pageTopShow{
                        display: flex;
                        .xian{
                            width: 2px;
                            height: 15px;
                            background: #fff;
                            border-radius: 1px;
                            margin-right: 9px;
                        }
                    }
                }
                .about_thr_right{
                    font-weight: 400;
                    font-size: 17px;
                    color: #1E1E1E;
                    font-family: Microsoft YaHei;
                    width: 565px;
                    text-align: center;
                    margin-left: 11px;
                    padding: 11px 0 150px;
                    .about_thr_rightT{
                        font-size: 11px;
                        font-weight: 300;
                        color: #3D3D3D;
                        margin-bottom: 28px;
                    }
                    .about_thr_rightF{
                        text-align: left;
                        text-indent:24px;
                        font-size: 12px;
                        margin-bottom: 10px;
                        line-height: 20px;
                    }
                    .about_thr_progress{
                        width: 518px;
                        height: 725px;
                        background: url("./img/progress2.png") no-repeat;
                        background-size: 518px 725px;
                        margin: 0 auto;
                    }
                }
                .height{
                    padding-bottom: 48px !important;
                }
            }
        }
    }
</style>
